module.exports = __webpack_public_path__ + "static/media/step-indicator-1of2.90e4c98f.svg";